import { mapState } from 'vuex'
import featuresByPlan from './featuresByPlan'
import featuresByPlanForSingporean from './featuresByPlan.singpore'
import featuresByPlanForVietnamese from './featuresByPlan.vietnam'
import featuresByPlanForEur from './featuresbyPlan.eur'
import { SLIDE_TYPE_LIMIT_TWO, SLIDES_TYPE_LIMIT_FIVE } from '@/constant/slideTypes'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      planUser: (state) => state.currentUser.plan,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    /*
      if user have active sub => priority active sub
      if user not have active sub
    / */
    fromJustNow() {
      if (this.isUserVietNam) {
        return '200,000'
      }
      if (this.isUserSingapore) {
        return 10.75
      }
      if (this.isUserEurope) {
        return 7.25
      }
      return 7.95
    },

    featuresByPlan() {
      if (this.isUserApplyNewPayment) {
        return featuresByPlan
      }
      if (this.isUserVietNam) {
        return featuresByPlanForVietnamese
      }
      if (this.isUserSingapore) {
        return featuresByPlanForSingporean
      }
      if (this.isUserEurope) {
        return featuresByPlanForEur
      }
      return featuresByPlan
    },
    isUserVietNam() {
      return ['Vietnam'].includes(this.currentUser.country)
    },
    isUserSingapore() {
      return ['Singapore'].includes(this.currentUser.country)
    },
    isUserEurope() {
      return [
        'Austria',
        'Belgium',
        'Croatia',
        'Cyprus',
        'Estonia',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Ireland',
        'Italy',
        'Latvia',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Netherlands',
        'Portugal',
        'Slovakia',
        'Slovenia',
        'Spain',
      ].includes(this.currentUser.country)
    },
    isUserApplyNewPayment() {
      return this.activeSubUser && this.activeSubUser.currency === 'usd'
    },
    activeSubUser() {
      return this.currentUser.myPlan && this.currentUser.myPlan.subscription
    },
    fullSymbolCurrency() {
      if (this.isUserApplyNewPayment) {
        return 'USD'
      }
      if (this.isUserSingapore) {
        return 'SGD'
      }
      if (this.isUserVietNam) {
        return 'VND'
      }
      if (this.isUserEurope) {
        return 'EUR'
      }
      return 'USD'
    },
    symbolCurrency() {
      if (this.isUserApplyNewPayment) {
        return '$'
      }
      if (this.isUserSingapore) {
        return 'S$'
      }
      if (this.isUserVietNam) {
        return '₫'
      }
      if (this.isUserEurope) {
        return '€'
      }
      return '$'
    },
  },

  methods: {
    isForPairPlan(typeObj) {
      if (this.planBenefit.abTest) {
        return false
      }
      if (this.planUser === 'free') {
        if (typeObj.isForPairPlan) {
          return true
        }
        const { slides } = this.presentation
        const countPickerAnswer = slides.filter((item) => SLIDES_TYPE_LIMIT_FIVE.includes(item.type)).length
        const countLimitTwo = slides.filter((item) => SLIDE_TYPE_LIMIT_TWO.includes(item.type)).length
        if (SLIDES_TYPE_LIMIT_FIVE.includes(typeObj.type) && countPickerAnswer >= 5) {
          return true
        }
        if (SLIDE_TYPE_LIMIT_TWO.includes(typeObj.type) && countLimitTwo >= 2) {
          return true
        }
      }
      return false
    },
  },
}
